import { render, staticRenderFns } from "./RichMenuList.vue?vue&type=template&id=104039fd&scoped=true&"
import script from "./RichMenuList.vue?vue&type=script&lang=js&"
export * from "./RichMenuList.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuList.vue?vue&type=style&index=0&id=104039fd&lang=scss&scoped=true&"
import style1 from "./RichMenuList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./RichMenuList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104039fd",
  null
  
)

export default component.exports